import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';
import axiosInstance from 'src/utils/axios';

export const getTotalData = createAsyncThunk('get/totalData', async () => {
    const response = await axiosInstance.get('/dashboard/total_data/');
    return response.data;
});

export const getTotalKWperMonth = createAsyncThunk('get/total_kw_per_month', async (year) => {
    const response = await axiosInstance.get(`/dashboard/total_kw_per_month_year/${year}`);
    return response.data;
});

export const getTotalChargerPerMonth = createAsyncThunk('get/total_charger_per_month', async (year) => {
    const response = await axiosInstance.get(`/dashboard/total_charger_per_month_year/${year}`);
    return response.data;
});

export const getPaymentData = createAsyncThunk('get/paymentData', async ({year, period, interval}) => {
    const response = await axiosInstance.get(`/dashboard/payment_data/${year}/${period}/${interval}/`);
    return response.data;
});

export const getPaymentDataProvider = createAsyncThunk('get/paymentDataProvider', async ({year, provider}) => {
    const response = await axiosInstance.get(`/dashboard/payment_data_provider/${year}/${provider}`);
    return response.data;
});

let date = new Date();

const initialState = {
    totalData: null,
    totalKWperMonth: {
        label: [],
        total_monthly_kw: []
    },
    totalChargerPerMonth: {
        label: [],
        total_monthly_charge: []
    },
    paymentDataProvider: null,
    kWChartYear: date.getFullYear().toString(),
    chargerChartYear: date.getFullYear().toString(),
    paymentData: {
        total_chargers: [],
        total_payments: []
    },
};

const dashboardSlice = createSlice({
    name: 'dashboard',
    initialState,
    extraReducers: {
        [getPaymentData.pending]: (state) => {
            state.isLoading = true;
        },
        [getPaymentData.fulfilled]: (state, action) => {
            state.paymentData = action.payload.data;
            state.isLoading = false;
        },
        [getPaymentData.rejected]: (state) => {
            state.isLoading = false;
        },
        [getTotalData.pending]: (state, action) => {
            state.loading = true;
        },
        [getTotalData.fulfilled]: (state, action) => {
            state.totalData = action.payload.data;
        },
        [getTotalData.rejected]: (state, action) => {
            state.loading = false;
        },
        [getTotalKWperMonth.pending]: (state, action) => {
            state.loading = true;
        },
        [getTotalKWperMonth.fulfilled]: (state, action) => {
            state.totalKWperMonth = action.payload.data;
            state.loading = false;
        },
        [getTotalKWperMonth.rejected]: (state, action) => {
            state.loading = false;
        },
        [getTotalChargerPerMonth.pending]: (state, action) => {
            state.loading = true;
        },
        [getTotalChargerPerMonth.fulfilled]: (state, action) => {
            state.totalChargerPerMonth = action.payload.data;
            state.loading = false;
        },
        [getTotalChargerPerMonth.rejected]: (state, action) => {
            state.loading = false;
        },
        [getPaymentDataProvider.pending]: (state, action) => {
            state.loading = true;
        },
        [getPaymentDataProvider.fulfilled]: (state, action) => {
            state.paymentDataProvider = action.payload.data;
            state.loading = false;
        },
        [getPaymentDataProvider.rejected]: (state, action) => {
            state.loading = false;
        },
    },

    reducers: {
        setKWChartYear: (state, action) => {
            state.kWChartYear = action.payload;
        },

        setChargerChartYear: (state, action) => {
            state.chargerChartYear = action.payload;
        },
    },
});

export const {setKWChartYear, setChargerChartYear} = dashboardSlice.actions;

export default dashboardSlice.reducer;
